// Get all elements with the class "em-milestone__item"
const timelineItems = document.querySelectorAll('.em-milestone__item:not(.em-milestone__item--no-animation)');

// Intersection Observer callback function
function handleIntersection(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('em-milestone__item--visible');
		}
	});
}

// Create an Intersection Observer instance
const observer = new IntersectionObserver(handleIntersection, {
	root: null, // Use the viewport as the root
	rootMargin: '0px', // No margin
	threshold: 0.75, // At least 75% of the element is visible
});

// Observe each timeline item
for (let i = 0; i < timelineItems.length; i++) {
	observer.observe(timelineItems[i]);
}

// Loop through each element and attach the event listener to watch for animation being completed.
const timelineItemEls = document.querySelectorAll('.em-milestone__item-body');

timelineItemEls.forEach((element) => {
	element.addEventListener('animationend', () => {
		element.querySelector('.em-milestone__circle').classList.add('em-milestone__circle--visible');
	});
});
